import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import pricingStyle from "assets/jss/material-kit-pro-react/views/pricingSections/pricingStyle.jsx";

function SectionPricing(props) {
  const { classes } = props;

  return (
    <div className={classes.pricingSection}>
      <h2 className={classes.title} style={{color:"black"}}>Pricing</h2>
      <GridContainer>
        <GridItem md={4} sm={4}>
          <Card plain pricing>
            <CardBody pricing>
              <h6
                className={classNames(classes.cardCategory, classes.textInfo)}
              >
                Classroom
              </h6>
              <h1 className={classes.cardTitle}>
                <small>$</small>1,999 <small>/yr</small>
              </h1>
              <ul>
                <li>
                  <b>1</b> Classroom
                </li>
                <li>
                  <b>40</b> Students
                </li>
                <li>
                  <b>55</b> Personal Contacts
                </li>
                <li>
                  <b>5.000</b> Messages
                </li>
              </ul>
              <Button href="#pablo" color="primary" round>
                Get started
              </Button>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem md={4} sm={4}>
          <Card raised pricing color="primary">
            <CardBody pricing>
              <h6 className={classes.cardCategory}>Small School</h6>
              <h1 className={classes.cardTitleWhite}>
                <small>$</small>4,032 <small>/yr</small>
              </h1>
              <ul>
                <li>
                  <b>4</b> Classrooms
                </li>
                <li>
                  <b>150</b> Students
                </li>
                <li>
                  <b>125</b> Personal Contacts
                </li>
                <li>
                  <b>15.000</b> Messages
                </li>
              </ul>
              <Button href="#pablo" color="white" round>
                Get started
              </Button>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem md={4} sm={4}>
          <Card plain pricing>
            <CardBody pricing>
              <h6
                className={classNames(classes.cardCategory, classes.textInfo)}
              >
                Large School
              </h6>
              <h1 className={classes.cardTitle}>
                <small>$</small>6,200 <small>/yr</small>
              </h1>
              <ul>
                <li>
                  <b>> 4</b> Classrooms
                </li>
                <li>
                  <b>> 150</b> Students
                </li>
                <li>
                  <b>550</b> Personal Contacts
                </li>
                <li>
                  <b>50.000</b> Messages
                </li>
              </ul>
              <Button href="#pablo" color="primary" round>
                Get started
              </Button>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(pricingStyle)(SectionPricing);



// WEBPACK FOOTER //
// ./src/views/PricingPage/Sections/SectionPricing.jsx